import React, { createContext, FC, useContext, useMemo } from 'react';

const InternalComponentContext = createContext<{ internal: boolean }>({ internal: false });

export const InternalComponent = ({ children, internal = false }: { children: React.ReactNode; internal: boolean }) => {
  const value = useMemo(() => ({ internal }), [internal]);

  return <InternalComponentContext.Provider value={value}>{children}</InternalComponentContext.Provider>;
};

export const useInternalComponent = () => useContext(InternalComponentContext);

export const withInternalComponents = <T extends {}>(Comp: FC<T>) => {
  return (props: T) => (
    <InternalComponent internal>
      <Comp {...props} />
    </InternalComponent>
  );
};
